import React, { useState, useRef } from 'react';
import {
  Collapse,
  Grid,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import './slideitens.css';
import UIModalExit from '../../../UI/ModalExit/UIModalExit';

const MainSlideItens = ({ ...children }) => {
  const [expanded, setExpanded] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [submenuStyle, setSubmenuStyle] = useState({});
  const itemRef = useRef(null);

  function toggleExpandedCollapse() {
    setExpanded(!expanded);
  }

  function toggleDialog() {
    setOpenDialog(!openDialog);
  }

  const handleMouseEnter = () => {
    if (children.open) return;
    if (itemRef.current) {
      const rect = itemRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const optionCount = children.options?.length || 0;

      let top;
      if (optionCount > 5 || children.name === 'Gestão') {
        top = 70;
      } else {
        const estimatedHeight = (optionCount + 1) * 38 + 20;
        if (rect.top + estimatedHeight > viewportHeight - 10) {
          top = Math.max(70, viewportHeight - estimatedHeight - 10);
        } else {
          top = rect.top;
        }
      }

      setSubmenuStyle({
        top: `${top}px`,
        maxHeight: `${viewportHeight - top - 10}px`,
      });
    }
  };

  return (
    <>
      <Grid
        ref={itemRef}
        className="main-base-slide-item"
        onMouseEnter={handleMouseEnter}
      >
        <Grid
          container
          direction="row"
          alignItems="center"
          justify={children.open ? 'flex-start' : 'center'}
          className="main-base-slide-item__item"
          onClick={children.exit ? toggleDialog : toggleExpandedCollapse}
        >
          {children.icon}

          {children.options && (
            <Hidden xsUp={children.open}>
              <List
                component="div"
                disablePadding
                className="main-base-slide-item__submenu"
                style={submenuStyle}
              >
                <span>{children.name}</span>
                {children.options.map((option, idx) => (
                  <ListItem
                    onClick={option.action}
                    key={idx}
                    button
                    style={{ padding: '5px 0px' }}
                  >
                    <ListItemText primary={option.name} />
                  </ListItem>
                ))}
              </List>
            </Hidden>
          )}

          <Hidden xsUp={!children.open}>
            <Grid
              container
              direction="column"
              className="main-base-slide-item__operador"
            >
              <span>{children.name}</span>
            </Grid>
          </Hidden>

          {children.open && <Grid item xs />}

          {/* segundo icone */}
          {children.open && !children.exit && (
            <IconButton onClick={toggleExpandedCollapse}>
              <ExpandLess className={!expanded ? 'display-none' : ''} />
              <ExpandMore className={expanded ? 'display-none' : ''} />
            </IconButton>
          )}
        </Grid>
        {children.open && children.options && (
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
            className="main-base-slide-item__collapse"
          >
            <List component="div" disablePadding>
              {children.options.map((option) => (
                <ListItem
                  key={children.options.indexOf(option)}
                  onClick={option.action}
                  button
                >
                  <ListItemText primary={option.name} />
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}

        <UIModalExit
          open={openDialog}
          toggleDialog={toggleDialog}
          exit={children.exit}
        />
      </Grid>
    </>
  );
};

export default MainSlideItens;
